
// import ChinaAds from '@/basejson/China'
// import AusAds from '@/basejson/Australia'
// import MalaysiaAds from '@/basejson/Malaysia'
// import TaiwanAds from '@/basejson/TaiWan'
// import countryDateCode from '@/basejson/countryDateCode'
/**
 * todo 将 address 相关缓存移植至此
 */
const state = {
  //   countryDateCode: countryDateCode.data,
  //   ChinaAds: ChinaAds.data,
  //   AusAds: AusAds.data,
  //   MalaysiaAds: MalaysiaAds.data,
  //   TaiWanAds: TaiwanAds.data
}
const mutations = {}
const actions = {}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/address.js